/* Cobify · Secciones de la landing (código propio) */
(function () {
  'use strict';

  /* Carrusel con puntos y autoplay opcional (solo cuando hay desplazamiento) */
  if (!customElements.get('cobify-slider')) {
    class CobifySlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cobify-slider__track');
        this.dots = Array.from(this.querySelectorAll('.cobify-slider__dot'));
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.current = 0;
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.index));
            this.restart();
          })
        );
        this.delay = Number(this.dataset.autoplay || 0) * 1000;
        if (this.delay > 0) {
          ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((ev) =>
            this.addEventListener(ev, () => this.stop(), { passive: true })
          );
          this.addEventListener('mouseleave', () => this.start());
          this.start();
        }
      }
      disconnectedCallback() {
        this.stop();
      }
      scrollable() {
        return this.track.scrollWidth - this.track.clientWidth > 4;
      }
      onScroll() {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => {
          const left = this.track.scrollLeft;
          let best = 0;
          let bestDist = Infinity;
          this.slides.forEach((slide, i) => {
            const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left - parseFloat(getComputedStyle(this.track).paddingLeft || 0));
            if (d < bestDist) {
              bestDist = d;
              best = i;
            }
          });
          if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4) best = this.slides.length - 1;
          this.setActive(best);
        });
      }
      setActive(i) {
        this.current = i;
        this.dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === i);
          dot.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }
      goTo(i) {
        const slide = this.slides[i];
        if (!slide) return;
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft || 0);
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft - pad, behavior: 'smooth' });
        this.setActive(i);
      }
      start() {
        this.stop();
        if (this.delay <= 0) return;
        this.timer = window.setInterval(() => {
          if (!this.scrollable() || document.hidden) return;
          this.goTo((this.current + 1) % this.slides.length);
        }, this.delay);
      }
      stop() {
        window.clearInterval(this.timer);
      }
      restart() {
        if (this.delay > 0) this.start();
      }
    }
    customElements.define('cobify-slider', CobifySlider);
  }

  /* Antes / Después */
  if (!customElements.get('cobify-compare')) {
    class CobifyCompare extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.cobify-compare__range');
        if (!this.range) return;
        const update = () => this.style.setProperty('--ba-pos', this.range.value + '%');
        this.range.addEventListener('input', update);
        this.range.addEventListener('change', update);
        update();
      }
    }
    customElements.define('cobify-compare', CobifyCompare);
  }
})();
